import './css/main.scss'
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import "@fontsource/poppins";
import 'leaflet/dist/leaflet.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./components/Home/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Products from "./components/Products/Products";
import ContactUs from "./components/ContactUs/ContactUs";
import TermsOfUse from "./components/TermsOfUse/TermsOfUse";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Login from "./components/Login/Login";
import CreateAccount from "./components/CreateAccount/CreateAccount";
import CartDetails from "./components/CartDetails/CartDetails";
import CheckOut from "./components/CheckOut/CheckOut";
import Orders from "./components/Orders/Orders";
import OrderHistory from "./components/OrderHistory/OrderHistory";
import ProductDetails from "./components/Products/ProductDetails";
import ScrollToTop   from "./components/ScrollToTop/ScrollToTop";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";

function App() {
  return (
      <Router>
          <ScrollToTop />
            <div className="App">
              <Routes>
                  <Route path="/" element={<Home/>} />
                  <Route path="/products" element={<Products/>} />
                  <Route path="/about-us" element={<AboutUs/>} />
                  <Route path="/contact-us" element={<ContactUs/>} />
                  <Route path="/terms-of-use" element={<TermsOfUse/>} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
                  <Route path="/product-details/:id" element={<ProductDetails/>} />
                  <Route path="/cart-details" element={<CartDetails/>} />
                  <Route path="/checkout" element={<CheckOut/>} />
                  <Route path="/orders/:orderId" element={<Orders/>} />
                  <Route path="/login" element={<Login/>} />
                  <Route path="/create-account" element={<CreateAccount/>} />
                  <Route path="/orderhistory" element={<OrderHistory/>} />
                  <Route path="/forgot-password" element={<ForgotPassword/>} />
              </Routes>
            </div>
      </Router>
  );
}

export default App;
